<!-- 价值再造体系 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_product.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="价值再造" en="VALUE REENGINEERING"></sub-title>
        <div class="list">
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/value_img1.png"
              alt="需求导向"
              class="post"
            />
            <div class="text">
              <div class="title">1. 需求导向：</div>
              <div class="line"></div>
              <div class="desc">
                深入了解掌握客户需求，以项目总体目标为指引，超越客户需求为导向，并将其贯穿到整个咨询服务过程的每个动作。
              </div>
            </div>
          </div>
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/value_img2.png"
              alt="价值创造"
              class="post"
            />
            <div class="text">
              <div class="title">2. 价值创造：</div>
              <div class="line"></div>
              <div class="desc">
                以客户需求为导向，深入研究分析挖掘服务过程中的客户需求点，根据需求点为客户提供有价值的服务和解决问题的方案，体现服务的价值所在。
              </div>
            </div>
          </div>
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/value_img3.png"
              alt="流程指引"
              class="post"
            />
            <div class="text">
              <div class="title">3. 流程指引：</div>
              <div class="line"></div>
              <div class="desc">
                有价值的咨询服务，价值点的创造必须以流程为指引，确保服务过程中各价值点呈现给客户，实现品质质量的全过程控制。
              </div>
            </div>
          </div>
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/value_img4.png"
              alt="标准规范"
              class="post"
            />
            <div class="text">
              <div class="title">4. 标准规范：</div>
              <div class="line"></div>
              <div class="desc">
                在工作流程的指引下，将流程中的各节点、活动及相应成果进行标准化、规范化管理，统一了员工的行为习惯和成果标准，极大客服了因员工个人行为习惯给产品质量带来的不确定性。
              </div>
            </div>
          </div>
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/value_img5.png"
              alt="绩效考核"
              class="post"
            />
            <div class="text">
              <div class="title">5. 绩效考核：</div>
              <div class="line"></div>
              <div class="desc">
                将员工的工作成果质量和效果与薪酬绩效融合，实行奖优罚劣，树立标杆，激发员工内趋力和执行力。
              </div>
            </div>
          </div>
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/value_img6.png"
              alt="职业习惯"
              class="post"
            />
            <div class="text">
              <div class="title">6. 职业习惯：</div>
              <div class="line"></div>
              <div class="desc">
                品控理念引领，价值创造为导向，统一思想，通过流程化、标准化规范员工的行为动作和工作成果，让员工养成正向积极的职业行为习惯。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/value_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 120px;

    .list {
      margin-top: 30px;

      .item {
        width: 100%;
        display: flex;

        & + .item {
          margin-top: 40px;
        }
        &:nth-child(2n) {
          flex-direction: row-reverse;
        }
        .post {
          width: 750px;
          height: 370px;
          flex-shrink: 0;
        }
        .text {
          flex-grow: 1;
          background-color: $theme;
          color: #fff;
          padding: 30px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .title {
            font-size: 24px;
            letter-spacing: 2px;
            font-weight: bold;
          }
          .line {
            width: 39px;
            height: 3px;
            margin: 40px 0;
            background-color: #fff;
          }
          .desc {
            text-indent: 2em;
            font-size: 18px;
            line-height: 36px;
          }
        }
      }
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .list {
        .item {
          display: block;

          & + .item {
            margin-top: 10px;
          }
          .post {
            width: 100%;
            height: 185px;
            display: block;
          }
          .text {
            padding: 5px;

            .title {
              font-size: 16px;
            }
            .line {
              width: 30px;
              height: 2px;
              margin: 10px 0;
            }
            .desc {
              font-size: 14px;
              line-height: 1.5;
            }
          }
        }
      }
    }
  }
}
</style>
